import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import clsx from 'clsx';
import { UtilActions } from '../../_redux';
import GuestMenu from '../AppMenu/GuestMenu';
import branchInfo from '../AppMenu/BranchInfo';
import LoginSignUp from './components/LoginSignUp';
import { SignUp, SignIn, ForgotPassword, Welcome } from '.';
import AppMenu from '../AppMenu/AppMenu';
import AppContext from '../../context';


const StyledLogin = styled.section`
  .menu-button {
    position: fixed;
    top: 12px;
    left: 18px;
    border: 0;
    background: rgba(0, 0, 0, 0);
    outline: none;
    z-index: 15;
    
    &:focus {
      border: 0;
      outline: none;
    }
    
    &:hover {
      svg {
        fill: #efefef;
        transition: fill .5s ease-in-out;
      }
    }
    
    &.login {
      svg {
        fill: #17936f;
      }
      
      &:hover {
        svg {
          fill: #127c5e;
        }
      }
    }
    
    &.welcome {
      &.visible {
        left: 5px;
      }
    }
    
    svg {
      width: 15px;
      height: 13px;
      fill: #fff;
      transition: fill .5s ease-in-out;
    }
  } 
  
  .Menu {
    top: 0;
    height: 100%;
  }
  
  .js-overlay {
    top: 0;
    height: 100%;
  }
  
  .login-container {
    position: relative;
    display: flex;
    height: 100vh;
  }
  
  @media screen and (max-width: 575px) {
    .login-container {
      height: auto;
    }
    
    .menu-button {
      left: 10px;
      
      &.welcome {
        &.visible {
          left: 10px;
        }
      }
    }
  }
`;

const mapStateToPrors = state => ({
  isMenuVisible: state.general.get('isMenuVisible'),
  isMobile: state.general.get('isMobile'),
});

const mapDispatchToProps = {
  TOGGLE_MENU: UtilActions.TOGGLE_MENU,
};

class Login extends React.Component {
  static propTypes = {
    welcome: PropTypes.bool,
    isMobile: PropTypes.bool,
    isMenuVisible: PropTypes.bool,
    className: PropTypes.string,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    TOGGLE_MENU: PropTypes.func.isRequired,
  }

  static contextType = AppContext

  static defaultProps = {
    className: '',
  }

  state = {
    scrolled: false,
  }

  componentDidMount() {
    if (this.context.auth.isAuthenticated()) {
      this.props.history.replace('/');
    }
    window.addEventListener('scroll', this.handleScroll);
    // this.recaptcha = document.querySelector('.grecaptcha-badge');
    // this.recaptcha.classList = ['.grecaptcha-badge', 'visible'];
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    // this.recaptcha.classList = ['.grecaptcha-badge'];
  }

  toggleMenu = () => {
    this.props.TOGGLE_MENU(!this.props.isMenuVisible);
  }

  closeMenu = e => {
    if (!!e && !!e.preventDefault) {
      e.preventDefault();
    }
    this.props.TOGGLE_MENU(false);
  }

  handleScroll = () => {
    const { isMobile, location: { pathname } } = this.props;
    if (isMobile) {
      const login = /^\/?login/.test(pathname);
      const y = (840 * (login ? 0.119 : 0.083)) - 24;
      if (!this.state.scrolled && window.scrollY > y) {
        this.setState({ scrolled: true });
      } else if (this.state.scrolled && window.scrollY <= y) {
        this.setState({ scrolled: false });
      }
    }
  }

  renderContent = () => {
    const { location: { pathname }, isMobile } = this.props;
    const login = /^\/?login/.test(pathname);
    const signUp = /^\/?signup/.test(pathname);
    const forgot = /^\/?forgot/.test(pathname);

    // Switch Child components depend on route pathname
    switch (true) {
    case login: return <SignIn isMobile={isMobile} />;
    case forgot: return <ForgotPassword isMobile={isMobile} />;
    case signUp: return <SignUp isMobile={isMobile} />;
    default: return <SignIn isMobile={isMobile} />;
    }
  }

  render() {
    const {
      className, isMenuVisible, isMobile, location: { pathname }, welcome,
    } = this.props;
    const { scrolled } = this.state;
    const signUp = /^\/?signup/.test(pathname);
    const isWelcome = welcome || /^\/?welcome/.test(pathname);
    const isChangeHandle = /^\/i\/change-handle$/.test(pathname);
    const isGreenButton = (signUp && !isMobile) || (isMobile && !scrolled);

    return (
      <StyledLogin className={className}>
        <button
          onClick={this.toggleMenu}
          type="button"
          className={clsx('menu-button', {
            signup: isGreenButton,
            login: !isGreenButton,
            welcome: isWelcome,
            visible: isMenuVisible,
          })}
          data-target="#offCanvasMenu"
          id="hamburger-menu"
        >
          {isMenuVisible ? (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
              <path d="M14.1,99.4L1.2,86.5l36.4-36.4L1.5,14L14.4,1.1l36.1,36.1L86.6,1.1L99.5,14L63.4,50.1l36.4,
                  36.4L86.9,99.4L50.5,63L14.1,99.4z"
              />
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14">
              <path d="M1,0.5h14c0.3,0,0.5,0.2,0.5,0.5v1.5C15.5,2.8,15.3,3,15,3H1C0.7,3,0.5,2.8,0.5,
                  2.5V1C0.5,0.7,0.7,0.5,1,0.5zM1,5.7h14c0.3,0,0.5,0.2,0.5,0.5v1.5c0,0.3-0.2,0.5-0.5,0.5H1C0.7,
                  8.3,0.5,8,0.5,7.8V6.2C0.5,6,0.7,5.7,1,5.7z M1,11h14c0.3,0,0.5,0.2,0.5,0.5V13c0,0.3-0.2,
                  0.5-0.5,0.5H1c-0.3,0-0.5-0.2-0.5-0.5v-1.5C0.5,11.2,0.7,11,1,11z"
              />
            </svg>

          )}
        </button>
        <div
          className={`js-overlay ${isMenuVisible ? 'visible' : ''} ${isMobile ? 'mobile' : ''}`}
          onClick={this.closeMenu}
        />
        {isWelcome ? (
          <React.Fragment>
            <AppMenu
              isMobile={isMobile}
              visible={isMenuVisible}
              onMenuClose={this.closeMenu}
            />
            <Welcome isChangeHandle={isChangeHandle} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <GuestMenu
              isMobile={isMobile}
              visible={isMenuVisible}
              onMenuClose={this.closeMenu}
              branchInfo={branchInfo}
            />
            <div className="login-container">
              {this.renderContent()}
              <LoginSignUp />
            </div>
          </React.Fragment>
        )}
      </StyledLogin>
    );
  }
}

export default connect(mapStateToPrors, mapDispatchToProps)(Login);
